// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 9261 ? "routes-Search" : chunkId) + "." + {"686":"5e891c52","2803":"9a477987","6711":"eb9822fe","9261":"e2e7552e"}[chunkId] + ".chunk.css";
};